import { Link } from "@/i18n/routing";
import { PageTitle } from "@repo/components";
import { getStrapiMedia } from "@repo/lib/utils";
import cx from "classnames";
import Image from "next/image";
const SpecialCategories = ({
  data
}) => {
  const {
    Card,
    title
  } = data || {};
  if (Card.length === 0) return null;
  const CardLink = ({
    item
  }) => <Link href={item?.url || "/"} className="group relative size-full overflow-hidden" data-sentry-element="Link" data-sentry-component="CardLink" data-sentry-source-file="SpecialCategories.jsx">
      {item?.media?.url && <Image src={getStrapiMedia(item?.media?.url)} alt={item?.title || `Special Category image ${item?.id}`} width={item?.media?.width} height={item?.media?.height} className="size-full object-cover transition-all duration-500 ease-in-out md:group-hover:scale-110 rtl:-scale-x-100 rtl:md:group-hover:-scale-x-110" />}
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
      {item?.title && <div className="absolute bottom-0 left-0 p-4 text-white">
          <h3 className="font-heading rtl:font-arabic text-sm font-normal tracking-wide md:text-xl">
            {item?.title}
          </h3>
        </div>}
    </Link>;
  return <section className="px-4 py-5 md:py-8" data-sentry-component="SpecialCategories" data-sentry-source-file="SpecialCategories.jsx">
      <div className="mx-auto md:max-w-screen-xl">
        {title && <PageTitle title={title} as="h2" className="rtl:font-arabic mb-5 text-start md:mb-9" variant="medium" />}
        {Card?.length > 0 && <div className="flex flex-wrap justify-start gap-2">
            {Card?.map((item, index) => {
          if (index % 3 === 2) return null;
          const isFullHeight = index % 3 === 0;
          const nextItem = Card[index + 1];
          return <div key={index} className={cx("grid w-[calc(50%-6px)] md:w-[calc(25%-9px)]", {
            "grid-rows-2 gap-2": !isFullHeight && nextItem,
            // Half items: 2 equal rows with gap
            "grid-rows-1": isFullHeight // Full items: single row
          })}>
                  <CardLink item={item} isFullHeight={isFullHeight} />
                  {!isFullHeight && nextItem && <CardLink item={nextItem} isFullHeight={false} />}
                </div>;
        })}
          </div>}
      </div>
    </section>;
};
export default SpecialCategories;